var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',[_vm._v(" "+_vm._s(_vm.$t('transactionCorrection'))+" ")]),_c('FormCsv',{attrs:{"request-endpoint":"transactionFileProcessTask/correction","button-label":_vm.$t('import')},on:{"imported":function($event){return _vm.fetchTasks()}}}),_c('ListCsv',{ref:"refListCsv"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }